class CartDiscountCode extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.accordian = this.querySelector('.discount-code-accordian');
    this.accordianTitle = this.querySelector('.discount-acc-header');
    this.input = this.querySelector('.discount-field-acc');
    this.button = this.querySelector('.submit-discount-field-acc');
    this.existingDiscounts = (this.dataset.discountCodes || '').split(',').filter(Boolean);
    this.errorWrapper = this.querySelector('.discount-field-error-message');
    this.removeBtns = this.querySelectorAll('.discount-remove-btn');

    this.addEventListener('click' , (event) =>{
    if(event.target.matches('.discount-remove-btn') || event.target.closest('.discount-remove-btn')){
    const target = event.target.matches('.discount-remove-btn') ? event.target : event.target.closest('.discount-remove-btn');
    this.removeDiscount(target);       
    } 
    })

    this.accordianTitle?.addEventListener('click', () => {
      this.accordian?.classList.toggle('open');
    });


    this.button?.addEventListener('click', () => {
      this.applyDiscount();
    });
  }

  removeDiscount(target) {
    const discountToRemove = target.dataset.discount;
    if (!discountToRemove || !this.existingDiscounts.includes(discountToRemove)) return;

    this.existingDiscounts = this.existingDiscounts.filter(d => d !== discountToRemove);

    const body = JSON.stringify({
      discount: this.existingDiscounts.join(','),
      sections_url: window.location.pathname,
    });

    fetch(`${theme.routes.cartUpdate}`, {
      ...this.fetchConfig(),
      body,
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);
        const discountCodes = parsedState.discount_codes || [];
        const stillApplied = discountCodes.some(d => d.code === discountToRemove && d.applicable);
        
        if (!stillApplied) { 
          target.classList.remove('has-error');
          this.errorWrapper?.classList.add('hidden');
            const cartForm = document.querySelector('cart-form');
        if (cartForm && cartForm.enableAjaxUpdate) {
          cartForm.refresh();
        } 
        return
          this.getSectionsToRender().forEach(section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
        } else {
          this.errorWrapper?.classList.remove('hidden');
          target.classList.add('has-error');
          this.errorWrapper.querySelector('.error-message-discount-acc').textContent =
            'This discount was not removed. Please try again.';
        }
      });
  }

  applyDiscount() {
    const newDiscount = this.input.value.trim();
    if (!newDiscount || this.existingDiscounts.includes(newDiscount)) return;

    const updatedDiscounts = [...this.existingDiscounts, newDiscount];

    const body = JSON.stringify({
      discount: updatedDiscounts.join(','), 
      sections_url: window.location.pathname,
    });

    fetch(`${theme.routes.cartUpdate}`, {
      ...this.fetchConfig(),
      body,
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);
        const discountCodes = parsedState.discount_codes || [];
        const appliedDiscount = discountCodes.find(discount => discount.code === newDiscount && discount.applicable);
        
        if (appliedDiscount) {
            this.input.value = ''
          this.classList.remove('has-error');
          this.errorWrapper?.classList.add('hidden');
          this.existingDiscounts = updatedDiscounts;
           const cartForm = document.querySelector('cart-form');
                if (cartForm && cartForm.enableAjaxUpdate) {
                cartForm.refresh();
                } 
                return
          this.getSectionsToRender().forEach(section => {
              const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id); 
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
        } else {
          this.errorWrapper?.classList.remove('hidden');
          this.classList.add('has-error');
          this.errorWrapper.querySelector('.error-message-discount-acc').textContent = 'This discount code is invalid';
        }
      });
  }

  getSectionsToRender() {
    return [
      {
        id: this.closest('.section-cart-drawer').getAttribute('id'),
        section: 'cart-drawer',
        selector: '.applied-discounts-list',
      },
    ];
  }

  fetchConfig() {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
    };
  }
    getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

window.customElements.define('cart-discount-code', CartDiscountCode);
